const paymentState = Object.freeze({
    NONE_SELECTED: 'NONE_SELECTED',
    PRE_PAYMENT: 'PRE_PAYMENT',
    //MODAL_OPENED: 'MODAL_OPENED',
    PAYMENT_TYPE_CHOSEN: 'PAYMENT_TYPE_CHOSEN',
    //ACCEPT_TOKEN_ACQUIRED: 'ACCEPT_TOKEN_ACQUIRED',
    //PAYMENT_FORM_OPEN: 'PAYMENT_FORM_OPEN',
    PAID: 'PAID',
    RECORDED: 'RECORDED',
    COOL_OFF: 'COOL_OFF',
    AUTH_ERROR: 'AUTH_ERROR',
    SAP_ERROR: 'SAP_ERROR'
  });
  
  export default paymentState;
  